/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Confirm_Heuristic_MatchesInputs */

const cs_import_confirm_heuristic_matches = /** @type {(inputs: Import_Confirm_Heuristic_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontroloval(a) jsem shody název + adresa a potvrzuji aktualizaci těchto inzerátů`)
};

const en_import_confirm_heuristic_matches = /** @type {(inputs: Import_Confirm_Heuristic_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I reviewed title + address matches and confirm updating those listings`)
};

/**
* | output |
* | --- |
* | "I reviewed title + address matches and confirm updating those listings" |
*
* @param {Import_Confirm_Heuristic_MatchesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_confirm_heuristic_matches = /** @type {((inputs?: Import_Confirm_Heuristic_MatchesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Confirm_Heuristic_MatchesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_confirm_heuristic_matches(inputs)
	return cs_import_confirm_heuristic_matches(inputs)
});